!function(n){n.fn.prepareTransition=function(){return this.each(function(){var i=n(this);i.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){i.removeClass("is-transitioning")});var t=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"],o=0;n.each(t,function(n,t){o||(o=parseFloat(i.css(t)))}),0!=o&&(i.addClass("is-transitioning"),i[0].offsetWidth)})}}(jQuery);

// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
(function(){function b(b,a){a=a||{bubbles:!1,cancelable:!1,detail:void 0};var c=document.createEvent("CustomEvent");c.initCustomEvent(b,a.bubbles,a.cancelable,a.detail);return c}if("function"===typeof window.CustomEvent)return!1;b.prototype=window.Event.prototype;window.CustomEvent=b})();

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      // Udundi - Added first if statement
      if (variant.inventory_quantity < 1 && this.variants.product.tags.includes('preorder')) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html("Preorder");
      } else if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }$('[data-product-price-discount]').text('$' + (variant.price/100).toFixed(2));$('[gc-data-product-price-discount]').text('$' + (variant.price/100).toFixed(2));var event = new CustomEvent('variant-change', {
        detail: { variant: variant }
      })

      document.dispatchEvent(event);
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      // Old Version
      //$(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);

      // Udundi Version
      if (sizedImgUrl != null) {
        var imageUrl;
        if (sizedImgUrl.indexOf('http') == 0) {
            imageUrl = slate.Image.removeProtocol(sizedImgUrl);
        } else {
          imageUrl = sizedImgUrl;
        }
        // Remove version number ex. '?v=1588967258'
        imageUrl = imageUrl.split('?v')[0];
        imageUrl = imageUrl.split('1200.')[0];
        // Select img element if the src contains imageUrl
        var variantImgElem = $('[data-product-featured-image][src*="'+ imageUrl +'"]');
        if (variantImgElem.length > 0) {
          var variantImgIndex = $('[data-product-featured-image]').index(variantImgElem);
          $('.product-carousel[data-flickity]').flickity('select', variantImgIndex);
        }
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.slider = (function() {

  function Slider(container) {
    this.$container = $(container);
    this.$prevBtn = this.$container.find('.slider__btn--left');
    this.$nextBtn = this.$container.find('.slider__btn--right');
    this.$track = this.$container.find('.slider__track');
    this.$trackItems = this.$container.find('.slider__track--items');
    this.$items = this.$container.find('.slider__item');
    this.$lastItem = this.$items.last();
    this.init();
  }

  Slider.prototype = $.extend({}, Slider.prototype, {

    init: function() {

      this.isAnimating = false;
      this.isScrolling = false;
      this.initEvents();
    },

    initEvents: function() {

      var _sliderOnClick = this.sliderOnClick.bind(this);
      this.$prevBtn.on('click', _sliderOnClick);
      this.$nextBtn.on('click', _sliderOnClick);

      var _trackOnScroll = this.trackOnScroll.bind(this);
      this.$track.on('scroll', _trackOnScroll);
    },

    sliderOnClick: function(evt) {

      var btn = $(evt.currentTarget);

      if (btn.hasClass('slider__btn--left')) {

        this.setScroll('left');

      } else if (btn.hasClass('slider__btn--right')) {

        this.setScroll('right');
      }
    },

    setScroll: function(direction) {
      this.getVisibileElements(direction);
    },

    trackOnScroll: function(direction) {

      // Clear our timeout throughout the scroll
      window.clearTimeout(this.isScrolling);

      // Set a timeout to run after scrolling ends
      this.isScrolling = setTimeout(function() {

          // Run the callback
        if (!this.isAnimating) {
          this.enableControls();
          this.setControlsState();
        }

      }.bind(this), 66);
    },

    getVisibileElements: function(direction) {

      // Make sure any dynamic appended elements are counted
      this.$items = this.$container.find('.slider__item');
      this.$lastItem = this.$items.last();

      var trackBox = this.$track[0].getBoundingClientRect(),
          itemBox;

      var i = 0,
          il = this.$items.length;

      if (direction === 'right') {

        for (; i < il; i += 1) {

          itemBox = this.$items[i].getBoundingClientRect();

          if (itemBox.right > trackBox.right) {
            this.animateTrack(trackBox.left - itemBox.left);
            break;
          }
        }
      } else if (direction === 'left') {

        for (var i = il - 1; i >= 0; i--) {

          itemBox = this.$items[i].getBoundingClientRect();

          if (itemBox.left < trackBox.left) {
            this.animateTrack( trackBox.right - itemBox.right);
            break;
          }

        }
      }
    },

    animateTrack: function(offset) {

      var raf = requestAnimationFrame || mozRequestAnimationFrame || webkitRequestAnimationFrame || msRequestAnimationFrame;
      if (raf){

        raf(function() {

          var initialScroll = this.$track[0].scrollLeft;

          this.$track[0].scrollLeft += -offset;

          var realOffset = this.$track[0].scrollLeft,
              deltaX = realOffset - initialScroll;

          this.$trackItems.css('transform', 'translateX(' + deltaX + 'px' + ')');
          var reflow = this.$track[0].offsetHeight;

          this.isAnimating = true;

          this.$trackItems.css('transition', 'transform ' + Math.abs(deltaX) + 'ms cubic-bezier(0.4, 0.0, 0.2, 1)');
          this.$trackItems.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){

            this.isAnimating = false;

            this.$trackItems.removeAttr('style');
            this.enableControls();
            this.setControlsState();
          }.bind(this));

          this.$trackItems.css('transform', 'translateX(' + 0 + 'px' + ')');
          this.disableControls();

        }.bind(this));

      } else {
        this.$track[0].scrollLeft += -offset;
      }
    },

    disableControls: function() {
      this.$prevBtn.prop('disabled', true);
      this.$nextBtn.prop('disabled', true);
    },

    enableControls: function() {
      this.$prevBtn.prop('disabled', false);
      this.$nextBtn.prop('disabled', false);
    },

    setControlsState: function() {

      var scrollLeft = this.$track[0].scrollLeft;

      if (scrollLeft === 0) {
        this.$prevBtn.prop('disabled', true);
      } else if (Math.round(this.$lastItem[0].getBoundingClientRect().right) === Math.round(this.$track[0].getBoundingClientRect().right)) {
        this.$nextBtn.prop('disabled', true);
      }
    }

  });

  $('.slider').each(function( index ) {
    new Slider(this);
  });

})();

theme.productGallery = (function() {

  function Gallery(container) {
    this.$container = $(container);
    this.$thumbs = this.$container.find('.slider__item a');
    this.$picture = this.$container.find('#ProductPhotoPicture');
    this.$img = this.$picture.find('img');
    this.init();
  }

  Gallery.prototype = $.extend({}, Gallery.prototype, {

    init: function() {
      this.initEvents();
    },

    initEvents: function() {

      var _thumbOnClick = this.thumbOnClick.bind(this);
      this.$thumbs.on('click', _thumbOnClick);
    },

    thumbOnClick: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      var thumb = $(evt.currentTarget),
          src = slate.Image.removeProtocol(thumb.attr('href')).split('?')[0],
          video = thumb.attr('data-video');

      this.$thumbs.removeClass('slider__item--selected');
      thumb.addClass('slider__item--selected');

      var newPicture = this.createNewPicture(src),
          newImg = newPicture.find('img');

      if (typeof document.body.style.transition !== 'string') {

        // No animation support
        $('#ProductPhotoPicture img').attr('src', slate.Image.getSizedImageUrl(src, '1024x'));

      } else {

        this.setTransitionendEvent(newImg);

        newImg.attr('src', slate.Image.getSizedImageUrl(src, '1024x'));
        $(newPicture).insertBefore('#ProductPhotoPicture');
      }

      if (video) {

        this.createVideo(video);

      } else {

        // Remove existing videos
        if ($('.product__gallery--video').length) {

          $('#ProductPhotoPicture').css('visibility', 'hidden');
          $('.product__gallery--video').remove();
        }

      }
    },

    createNewPicture: function(src) {
      src = src.split('?')[0];
      var newPicture = $('<picture id="ProductPhotoPictureNew"></picture'),
          source1 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '300x') + '" media="(max-width: 320px)">'),
          source2 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '360x') + '" media="(max-width: 400px)">'),
          source3 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '553x') + '" media="(max-width: 600px)">'),
          source4 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '975x') + '" media="(max-width: 1023px)">'),
          source5 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '850x') + '" media="(max-width: 1400px)">'),
          newImg = document.createElement('img');

      newImg.setAttribute('data-master', src);
      newPicture.append(source1).append(source2).append(source3).append(source4).append(source5).append(newImg);

      $('#ProductPhotoPicture').css('filter', 'grayscale(1)');

      return newPicture;
    },

    setTransitionendEvent: function(newImg) {

      newImg.one('load', function() {

        $('#ProductPhotoPicture').one('transitionend', function() {
          $('#ProductPhotoPicture').remove();
          $('#ProductPhotoPictureNew').attr('id', 'ProductPhotoPicture');
        });

        $('#ProductPhotoPicture').css('opacity', 0);
      });
    },

    createVideo: function(src) {

      // Video already loaded or browser does not support video
      if($('.product__gallery--video').length || typeof HTMLVideoElement !== 'function') {
        return;
      }

      var video = $('<video class="product__gallery--video" src="' + src + '" controls></video>'),
          scream = $('<div class="product__gallery--video" aria-hidden="true"></div>')
      $('.product__gallery--main').append(scream).append(video);

      video[0].play();
    }

  });

  $('.product__gallery').each(function( index ) {
    new Gallery(this);
  });

})();

theme.productGalleryMobile = (function() {

  function GalleryMobile(container) {
    this.$container = $(container);
    this.$thumbs = this.$container.find('.slider__item a');
    this.$arrows = this.$container.find('.product__gallery--main .slider__btn');

    this.init();
  }

  GalleryMobile.prototype = $.extend({}, GalleryMobile.prototype, {

    init: function() {
      this.initEvents();
    },

    initEvents: function() {

      var _arrowOnClick = this.arrowOnClick.bind(this);
      this.$arrows.on('click', _arrowOnClick);
    },

    arrowOnClick: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      var arrow = $(evt.currentTarget),
          direction = arrow.attr('aria-label').toLowerCase();

      if (direction === 'next') {

        var selected = this.$container.find('.slider__item--selected').parent(),
            next = selected.next().find('a');

        if (next.length) {
          next.click();
        } else {
          this.$thumbs.eq(0).click();
        }

      } if (direction === 'previous') {

        var selected = this.$container.find('.slider__item--selected').parent(),
            prev = selected.prev().find('a');

        if (prev.length) {
          prev.click();
        } else {
          this.$thumbs.eq(this.$thumbs.length - 1).click();
        }
      }
    }
  });

  $('.product__gallery').each(function( index ) {
    new GalleryMobile(this);
  });

})();

theme.imageZoom = (function() {

  function ImageZoom(containerID) {

    this.containerID = containerID;
    this.isZoomOpen = false;
    this.init();
  }

  ImageZoom.prototype = $.extend({}, ImageZoom.prototype, {

    init: function() {
      this.initEvents();
    },

    initEvents: function() {

      var _onImgClick = this.onImgClick.bind(this);
      $(document).on('click', '#ProductPhotoPicture img', _onImgClick);

      var _onZoomClick = this.onZoomClick.bind(this);
      $(document).on('click', '#ProductPhotoPictureZoom', _onZoomClick);
    },

    onImgClick: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      var img = $(evt.currentTarget),
          src = img.attr('data-master');

      if (this.isZoomOpen) {
        return;
      } else {
        this.isZoomOpen = true;
      }

      var newPicture = $('<picture id="ProductPhotoPictureZoom"></picture'),
          source1 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '300x') + '" media="(max-width: 320px)">'),
          source2 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '360x') + '" media="(max-width: 400px)">'),
          source3 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '553x') + '" media="(max-width: 600px)">'),
          source4 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '975x') + '" media="(max-width: 1023px)">'),
          source5 = $('<source srcset="' + slate.Image.getSizedImageUrl(src, '850x') + '" media="(max-width: 1400px)">'),
          newImg = document.createElement('img');

      newImg.setAttribute('data-master', src);
      newPicture.append(source1).append(source2).append(source3).append(source4).append(source5).append(newImg);

      newImg.src = slate.Image.getSizedImageUrl(src, '2048x');

      $(newImg).one('load', function() {

        $(document.body).append(newPicture);

        var oldImg = $('#ProductPhotoPicture img'),
            newImg = $(this),
            oldBox = oldImg[0].getBoundingClientRect(),
            newBox = newImg[0].getBoundingClientRect();

        var s = oldBox.width / newBox.width,
            x = oldBox.left - newBox.left,
            y = oldBox.top - newBox.top;

        newImg.css('transform', 'translate(' + x + 'px, ' + y + 'px) scale(' + s + ') ');
        var reflow = newImg.width()
        newImg.css('transition', 'transform .32s cubic-bezier(0.4, 0.0, 0.2, 1), transform-origin .32s cubic-bezier(0.4, 0.0, 0.2, 1)');

        newImg.css('transform', 'translate(-50%, -50%) scale(' + 1 + ') ');
        newImg.css('transform-origin', '0% 60%');

      });
    },

    onZoomClick: function(evt) {
      $('#ProductPhotoPictureZoom').remove();
      this.isZoomOpen = false;
    }
  });

  new ImageZoom('#ProductPhotoPicture');

})();

theme.productSizeGuide = (function() {

  function ProductSizeGuide(container) {
    this.$btn = $(container);
    this.$panel = $('#' + this.$btn.attr('aria-controls'));

    this.init();
  }

  ProductSizeGuide.prototype = $.extend({}, ProductSizeGuide.prototype, {

    init: function() {
      this.initEvents();
    },

    initEvents: function() {

      var _btnOnClick = this.btnOnClick.bind(this);
      this.$btn.on('click', _btnOnClick);
    },

    btnOnClick: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      if (this.$panel.attr('aria-hidden')) {
        this.$panel.removeAttr('aria-hidden');
      } else {
        this.$panel.attr('aria-hidden', true);
      }
    }

  });

  $('.js-panel-open').each(function( index ) {
    new ProductSizeGuide(this);
  });

})();


theme.carouselMobile = (function() {

  function CarouselMobile(container) {
    this.$container = $(container);
    this.$btns = this.$container.find('.carousel__btn');
    this.$slides = this.$container.find('.carousel__slide');

    this.init();
  }

  CarouselMobile.prototype = $.extend({}, CarouselMobile.prototype, {

    init: function() {
      this.initEvents();
    },

    initEvents: function() {

      var _btnOnClick = this.btnOnClick.bind(this);
      this.$btns.on('click', _btnOnClick);
    },

    btnOnClick: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      var btn = $(evt.currentTarget),
          index = btn.attr('data-slide');

      this.$btns.removeAttr('aria-pressed');
      btn.attr('aria-pressed', true);

      this.$slides.addClass('small--hide');
      this.$slides.eq(index).removeClass('small--hide')
    }
  });

  $('.carousel').each(function( index ) {
    new CarouselMobile(this);
  });

})();


theme.headerSearch = (function() {

  $('.site-header__search-toggle').on('mouseenter', function(){
    $('#HeaderSearchPanel').removeAttr('aria-hidden');
    $('#HeaderSearchPanel input').focus();
  });

  $('.site-header__search-toggle').on('mouseleave', function(){
    $('#HeaderSearchPanel').attr('aria-hidden', true);
  });

})();

theme.headerDesktopDropDown = (function() {

  $('.js-open-drop-down').on('mouseenter', function(){
    // $(this).addClass('nav-open');
    // $('#DesktopDropDown').removeAttr('aria-hidden');
  });

  $('.js-open-drop-down').on('mouseleave', function(){
    // $(this).removeClass('nav-open');
    // $('#DesktopDropDown').attr('aria-hidden', true);
  });

  $('.js-open-drop-down > a').on('click', function(){
    if ($(this).hasClass('nav-open')) {
      $(this).removeClass('nav-open');
      $('#DesktopDropDown').attr('aria-hidden', true);
    } else {
      $(this).addClass('nav-open');
      $('#DesktopDropDown').removeAttr('aria-hidden');
    }
  })

})();

theme.productTabs = (function() {
  $(document).on('click', '[role="tab"]', function(evt) {

    evt.preventDefault();

    var root = $(this).parents('[role="tablist"]'),
        newTab = $(this),
        tabs = root.find('[role="tab"]'),
    	control = newTab.attr('aria-controls'),

        newPanel = $('#' + control),
        rootPanels = newPanel.parent(),
        oldPanel = rootPanels.find('[role="tabpanel"]').not('[aria-hidden="true"]');

    tabs.attr('aria-selected', false).attr('tabindex', -1);
    newTab.attr('aria-selected', true).attr('tabindex', 0);

    oldPanel.attr('aria-hidden', true);
    newPanel.attr('aria-hidden', false);

  });

})();

theme.FAQPage = (function() {


  function FAQPage(container) {

    this.$btn = $(container);
    this.$panel = $('#' + this.$btn.attr('aria-controls'));

    this.init();
  }

  FAQPage.prototype = $.extend({}, FAQPage.prototype, {

    init: function() {

      this.WebAnimations = false;
      if (typeof Element.prototype.animate === 'function') {
        this.WebAnimations = true;
      }

      this.initEvents();
    },

    initEvents: function() {

      var _toggle = this.toggle.bind(this);
      this.$btn.on('click', _toggle);
    },

    toggle: function(evt) {

      evt.preventDefault();
      evt.stopPropagation();

      if (this.$btn.attr('aria-expanded') === 'false') {
        this.open();
      } else {
        this.close();
      }
    },

    open: function() {

      this.$btn.attr('aria-expanded', true);
      this.$panel.removeAttr('aria-hidden');

      if (this.WebAnimations) {

        this.$panel[0].animate([
          {
            maxHeight: '0px'
          }, {
            maxHeight: this.$panel.height() + 'px'
          }
        ], {
          duration: 420,
          iterations: 1,
          fill: 'backwards',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });
      }
    },

    close: function() {

      this.$btn.attr('aria-expanded', false);

      if (this.WebAnimations) {

        var animation = this.$panel[0].animate([
          //keyframes
          {
            maxHeight: this.$panel.height() + 'px'
          }, {
            maxHeight: '0px'
          }
        ], {
          duration: 420,
          iterations: 1,
          fill: 'both',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });

        animation.onfinish = function(evt) {
          this.$panel.attr('aria-hidden', true);
          animation.cancel();
        }.bind(this);

      } else {
      	this.$panel.attr('aria-hidden', true);
      }
    }

  });

  $('.faq-question').each(function(index) {
    new FAQPage(this);
  });

})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

theme.MobileDrawerNav = (function() {

  function MobileDrawerNav(container) {

    this.$btn = $(container);
    this.$panel = this.$btn.parent().find('.mobile-nav__dropdown').eq(0);
    this.$content = this.$panel.find('.mobile-nav__dropdown--list');

    this.menuIsOpen = false;
    this.init();
  }

  MobileDrawerNav.prototype = $.extend({}, MobileDrawerNav.prototype, {

    init: function() {

      this.WebAnimations = false;

      if (typeof Element.prototype.animate === 'function') {
        this.WebAnimations = true;
      }

      this.initEvents();
    },

    initEvents: function() {

      var _btnOnClick = this.btnOnClick.bind(this);
      this.$btn.on('click', _btnOnClick);

    },

    btnOnClick: function(evt) {

      evt.preventDefault();
	  evt.stopPropagation();

      if (this.$panel.attr('aria-hidden')) {
        this.open();
      } else {
        this.close();
      }

    },

    open: function() {

      this.menuIsOpen = true;
      this.$panel.prepareTransition();
      this.$panel.removeAttr('aria-hidden');
      this.$btn.attr('data-open', true);
      var height = this.$panel.height();

      if (this.WebAnimations) {

        var animation = this.$panel[0].animate([
          { height: '0px' },
          { height: height + 'px' }
        ], {
          duration: 400,
          iterations: 1,
          fill: 'backwards',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });

        this.$content[0].animate([
          { transform: 'translateY(-8px)' },
          { transform: 'translateY(0px)' }
        ], {
          duration: 400,
          iterations: 1,
          fill: 'both',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });

      } else {

        this.$panel.css('height', '0px');
        this.$panel.css('transition', 'all .4s');
        this.$content.css('transition', 'transform .4s');

        this.$panel.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(evt) {
          evt.stopPropagation();
          this.$panel.removeAttr('style');
          this.$panel.prepareTransition({ disableExisting: true });
        }.bind(this));

        var reflow = this.$panel.height();
        this.$panel.css('height', height + 'px');
        this.$content.css('transform', 'translateY(0px)');
      }
    },

    close: function() {

      this.menuIsOpen = false;
      var height = this.$panel.height();
      this.$btn.removeAttr('data-open');

      if (this.WebAnimations) {

         this.$panel[0].animate([
          { height: height + 'px' },
          { height: '0px' }
        ], {
          duration: 400,
          iterations: 1,
          fill: 'backwards',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });

        var animation = this.$content[0].animate([
          { transform: 'translateY(0px)' },
          { transform: 'translateY(-8px)' }
        ], {
          duration: 400,
          iterations: 1,
          fill: 'both',
          easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
        });

        animation.onfinish = function(evt){
          this.$panel.attr('aria-hidden', true);
        }.bind(this);

      } else {
        this.$panel.css('height', height + 'px');
        this.$panel.css('transition', 'all .4s');

        this.$panel.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(evt) {
          evt.stopPropagation();
          this.$panel.removeAttr('style');
          this.$panel.prepareTransition({ disableExisting: true });
        }.bind(this));

        this.$panel.prepareTransition();
        this.$panel.attr('aria-hidden', true);
        var reflow = this.$panel.height();
        this.$panel.css('height', 0 + 'px');
        this.$content.css('transform', 'translateY(0px)');
      }
    }

  });

  $('.js-mobile-sub-menu').each(function( index ) {
    new MobileDrawerNav(this);
  });

  return MobileDrawerNav;

})();


$(document).ready(function() {

  // Product swatches
  $('form[action^="/cart/add"] .input-swatch').on('change', function(){

    var input = $(this),
        value = input.val(),
        index = input.attr('data-index'),
        select = $('#SingleOptionSelector-' + index);

    // 3rd Party APPs bug
    if ("createEvent" in document) {
      select.val(value)
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      select[0].dispatchEvent(evt);
    } else {
      select.val(value).trigger('change');
    }

  });


  // Contact page trigger chat
  $('.js-trigger-chat').on('click', function(evt){
    evt.preventDefault();

    if (typeof SnapEngage === 'object' && typeof SnapEngage.startChat === 'function') {
      SnapEngage.startChat();
    }

  });
});

// $('.homepage-featured-products').find()

// $(document).ready(function() {
//   $("body").css("padding-top", $("header").outerHeight(true) + "px");
// });
